import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *历史消息列表
 * @param params
 * 
*/

export const chatList = params => Http.get(`${baseUrl}/chat/msg`, { params })

/**
 *发送聊天消息
 * @param params
 * 
*/

export const sendChat = params => Http.post(`${baseUrl}/chat/msg`,  params )
